// Gallery thumbnail → variant sync (Warehouse/Flickity)
(function() {
  function getVariants() {
    try {
      const scripts = document.querySelectorAll('script[type="application/json"]');
      for (let s of scripts) {
        const d = JSON.parse(s.innerHTML);
        if (d.product && d.product.variants) return d.product.variants;
      }
    } catch(e) {}
    return null;
  }

  function syncVariantFromMediaId(mediaId) {
    const variants = getVariants();
    if (!variants) return;

    const matched = variants.find(v => v.featured_media && String(v.featured_media.id) === String(mediaId));
    if (!matched) return;

    // Find the main product form (not recommendations)
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    // Try each option value
    matched.options.forEach((optionValue) => {
      const radio = form.querySelector(`input[type="radio"][value="${CSS.escape(optionValue)}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function attachListeners() {
    document.querySelectorAll('a.product-gallery__thumbnail').forEach(thumb => {
      if (thumb.dataset.syncBound) return;
      thumb.dataset.syncBound = '1';
      thumb.addEventListener('click', function() {
        const mediaId = this.dataset.mediaId;
        if (mediaId) setTimeout(() => syncVariantFromMediaId(mediaId), 50);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', attachListeners);
  setTimeout(attachListeners, 1000);
})();
